import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  coinStoresForEdit: {},
  lastError: null,
  currency: [],
  virtualCurrencyListttt:[]
};

export const callTypes = {
  list: "list",
  action: "action",
};
export const Slice = createSlice({
  name: "coinStores",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
      state.exportData = [];
    },
    // singleItemFetched
    //   singleItemFetched: (state, action) => {
    //     state.actionsLoading = false;
    //     state.coinStoresForEdit = action.payload.coinStoresForEdit;
    //     console.log("fjdfbdjfbdjfbdjfndgndjfgjfdg", action.payload.coinStoresForEdit)
    //     state.error = null;
    // },

    singleItemFetched: (state, action) => {
      // console.log(action.payload.coinStoresForEdit, "------------");
      state.actionsLoading = false;
      state.coinStoresForEdit = action.payload.coinStoresForEdit;
      state.error = null;
    },

    // listFetched
    listFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // itemCreated
    itemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.entities.push(action.payload.item);
      state.entities = [];
    },
    country: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.country = entities;
      // state.totalCount = totalCount;
  },
    // itemUpdated
    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.item._id) {
      //     return action.payload.item;
      //   }
      //   return entity;
      // });
      state.entities = [];
    },
    // itemDeleted
    itemDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },
    // itemsDeleted
    itemsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => !action.payload.ids.includes(el.id)
      );
    },
    // itemStatusUpdated
    itemStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map((entity) => {
        if (ids.findIndex((id) => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    },
    resetStore: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.totalCount = 0;
      state.entities = [];
      state.coinStoresForEdit = {};
      state.lastError = null;
    },
    CountryList: (state, action) => {
      const { countryList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryList = countryList;
    },

    CountryDropdownList: (state, action) => {
      const { countryDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryDropdownList = countryDropdownList;
    },

    avatarcatDropdownList: (state, action) => {
      const { avatarDropdownListt } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.avatarDropdownListt = avatarDropdownListt;
    },
    virtualCurrencyList: (state, action) => {
      const { list } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.virtualCurrencyListttt = list;
    },
    avatarcatDropdownList1: (state, action) => {
      const { avatarDropdownListt1 } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.avatarDropdownListt1 = avatarDropdownListt1;
    },

    currency: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.currency = entities;
      // state.totalCount = totalCount;
    },
  },
});
